import TranslatedText from "@components/items/display/TranslatedText";
import { handleAppDownload } from "@utils/helpers/handleAppDownload";

export const AppDownload = ({
  language = "ar",
}: {
  language?: "ar" | "en";
}) => {
  return (
    <div className="mt-[28px]" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="mx-auto w-[260px] text-center text-[16px] font-medium text-white sm:w-full">
        {language === "ar" ? (
          <TranslatedText text="onboarding.titles.you can download the app by clicking on the button below" />
        ) : (
          "You can download the app by clikcing on the icon below"
        )}
      </div>
      <div className="mt-[15px] flex h-[41px] items-center justify-center sm:h-[46px]">
        <img
          id="apple"
          src={
            language === "ar"
              ? "/assets/images/apple.png"
              : "/assets/images/apple-en.png"
          }
          alt="apple"
          className="h-full w-[142px] cursor-pointer sm:w-[160px]"
          style={{ WebkitTapHighlightColor: "transparent" }}
          onClick={() => {
            handleAppDownload("apple");
          }}
        />
        <img
          id="android"
          src={
            language === "ar"
              ? "/assets/images/android.png"
              : "/assets/images/android-en.png"
          }
          alt="android"
          className={`h-full w-[142px] sm:w-[160px] ${
            language === "ar"
              ? "mr-[5px] sm:mr-[16px]"
              : "ml-[5px] sm:ml-[16px]"
          } cursor-pointer`}
          style={{ WebkitTapHighlightColor: "transparent" }}
          onClick={() => {
            handleAppDownload("android");
          }}
        />
      </div>
    </div>
  );
};
